export const PosSubscriptionServices = {
	PosSystem: {
		name: "posSystem",
		displayName: "POS System",
		defaultPrice: {
			monthly: "99.95",
			annually: "999.50",
		},
		discount: {
			monthly: "49.91",
			annually: "0.00",
		},
	},
	MarketingServices: {
		value: 1,
		name: "marketingServices",
		displayName: "Marketing Services",
		defaultPrice: {
			monthly: "99.95",
			annually: "999.50",
		},
	},
	IpPhoneService: {
		name: "ipPhoneService",
		displayName: "IP Phone Service",
		defaultPrice: {
			monthly: {
				one: "35.00",
				several: "30.00",
			},
		},
	},
	TapToPay: {
		name: "tapToPay",
		displayName: "Tap To Pay",
		defaultPrice: {
			monthly: "4.95",
		},
	},
	SalonInTheBox: {
		name: "salonInTheBox",
		displayName: "Salon In The Box",
		defaultPrice: {
			oneTime: "0.00",
		},
	},
	SmsService: {
		name: "smsService",
		displayName: "SMS Service",
		defaultPrice: {
			monthly: "0.00",
			annually: "0.00",
			consumption: "0.00",
			oneTime: "0.00",
		},
	},
	SmsMessage: {
		name: "smsMessage",
		displayName: "SMS Message",
		defaultPrice: {
			monthly: "0.00",
			annually: "0.00",
			consumption: "0.00",
			oneTime: "0.00",
		},
	},
	SmsSetup: {
		name: "smsSetup",
		displayName: "SMS Setup",
		defaultPrice: {
			monthly: "0.00",
			annually: "0.00",
			consumption: "0.00",
			oneTime: "0.00",
		},
	},
};
